import {
  DistributionRequestListModule,
  IntermediaryInformationCardModule,
  IntermediaryPaymentMethodModule,
} from '@folio/modules';
import type { IntermediaryInformationCardModuleField } from '@folio/modules/IntermediaryInformationCardModule/IntermediaryInformationCardModule';

const intermediaryFields = [
  {
    accessorKey: 'customFields.garageName',
    key: 'garageName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'companyInfo.siret',
    key: 'siret',
    type: 'siret',
    allowEdition: true,
  },
  {
    accessorKey: 'companyInfo.siren',
    key: 'siren',
    type: 'text',
  },
  {
    accessorKey: 'companyInfo.name',
    key: 'name',
    type: 'text',
  },
  {
    accessorKey: 'companyInfo.location.address',
    key: 'address',
    type: 'text',
  },
  {
    accessorKey: 'companyInfo.location.postCode',
    key: 'postCode',
    type: 'postcode',
  },
  {
    accessorKey: 'companyInfo.location.city',
    key: 'city',
    type: 'text',
  },
  {
    accessorKey: 'companyInfo.nafCode',
    key: 'nafCode',
    type: 'text',
  },
  {
    accessorKey: 'customFields.garageEmployeeCount',
    key: 'garageEmployeeCount',
    type: 'number',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.basePriceDiscount',
    key: 'basePriceDiscount',
    type: 'number',
    allowEdition: true,
  },
] as const as IntermediaryInformationCardModuleField[];

const contactFields = [
  {
    accessorKey: 'customFields.contactLastName',
    key: 'contactLastName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactFirstName',
    key: 'contactFirstName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactEmail',
    key: 'contactEmail',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.contactPhoneNumber',
    key: 'contactPhoneNumber',
    type: 'text',
    allowEdition: true,
  },
] as const as IntermediaryInformationCardModuleField[];

const ceoFields = [
  {
    accessorKey: 'customFields.directorLastName',
    key: 'directorLastName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.directorFirstName',
    key: 'directorFirstName',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.directorEmail',
    key: 'directorEmail',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.directorPhoneNumber',
    key: 'directorPhoneNumber',
    type: 'text',
    allowEdition: true,
  },
  {
    accessorKey: 'customFields.directorPosition',
    key: 'directorPosition',
    type: 'text',
    allowEdition: true,
  },
] as const as IntermediaryInformationCardModuleField[];

export function IntermediaryDetails() {
  return (
    <>
      <DistributionRequestListModule />

      <IntermediaryInformationCardModule
        titleKey="companyInformation"
        fields={intermediaryFields}
      />

      <IntermediaryInformationCardModule titleKey="contactInformation" fields={contactFields} />

      <IntermediaryInformationCardModule titleKey="directorInformation" fields={ceoFields} />

      <IntermediaryPaymentMethodModule />

      <IntermediaryInformationCardModule
        titleKey="comment"
        fields={[
          {
            key: 'comment',
            accessorKey: 'customFields.comment',
            type: 'text',
            allowEdition: true,
          },
        ]}
      />
    </>
  );
}
